let storage = localStorage;
function getItem(key) {
    return storage.getItem(key);
}
function setItem(key, value) {
    let newVal = value;
    if (typeof value !== 'string') {
        newVal = JSON.stringify(value)
    }
    return storage.setItem(key, newVal);
}
function removeItem(key) {
    return storage.removeItem(key);
}
function clear() {
    return storage.clear();
}
export { getItem, setItem, removeItem, clear };
export default { getItem, setItem, removeItem, clear };
